import { render, staticRenderFns } from "./DocumentsStep.vue?vue&type=template&id=543900b8&scoped=true"
import script from "./DocumentsStep.vue?vue&type=script&lang=js"
export * from "./DocumentsStep.vue?vue&type=script&lang=js"
import style0 from "./DocumentsStep.vue?vue&type=style&index=0&id=543900b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543900b8",
  null
  
)

export default component.exports